import { syncAction } from '@/lib/action';
import type { UiApprovalStampPosition } from '@/domain/ui/helpers';

export const toggleDocumentHotkeysModalAction = syncAction('UI/TOGGLE_DOCUMENT_HOTKEYS_MODAL');
export const toggleWorkspaceHotkeysModalAction = syncAction('UI/TOGGLE_WORKSPACE_HOTKEYS_MODAL');
export const toggleAFPanelAction = syncAction('UI/TOGGLE_APPROVAL_FLOW_PANEL');
export const setUiApprovalStampPositionAction = syncAction<UiApprovalStampPosition | null>(
  'UI/SET_APPROVAL_STAMP_POSITION',
);
export const setUiWorkspaceContextMenuAction = syncAction('UI/SET_WORKSPACE_CONTEXT_MENU');
export const setUiSelectOpenAction = syncAction('UI/SET_SELECT_OPEN');
export const setUiDrawerOpenAction = syncAction('UI/SET_DRAWER_OPEN');
export const addUiDeferredToastAction = syncAction('UI/ADD_DEFERRED_TOAST');
export const clearUiDeferredToastsAction = syncAction('UI/RESET_DEFERRED_TOASTS');
export const setUiExtractedFieldsHighlightedAction = syncAction<boolean>('UI/SET_EXTRACTED_FIELDS_HIGHLIGHTED');
export const resetUiExtractedFieldsHighlightedAction = syncAction('UI/RESET_EXTRACTED_FIELDS_HIGHLIGHTED');
